module.exports = __webpack_public_path__ + "img/logo-user.feeeac8.png";